<div class="row"></div>
<div style="text-align:right" class="col-md-3 offset-md-9" *ngIf="!hideAddDocumentButton">
    <button type="button" kendoButton [primary]="true" routerLinkActive="active" [icon]="'add'"
        (click)="openUploadDocumentDialog(uploadDocumentDialog)" [disabled]="disableAddDocButton">Add document
    </button>
</div>
<div class="data-view-wrapper mt-3">
    <kendo-grid [data]="uploadFileList" [columnMenu]="true" filterable="menu" [sortable]="true" [selectable]="true"
        [resizable]="true">
        <kendo-grid-column field="Document Name" [style]="{'cursor': 'pointer'}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.displayFileName">
                    <span class="hyperlink" (click)="enablePreviewDialog(previewDocumentDialog, dataItem)">{{dataItem.displayFileName}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Document Type">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.documentTypeName">
                    <span>{{dataItem.documentTypeName}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Description">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.description">
                    <span>{{dataItem.description}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Attached Date">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{dataItem.createdDate | date}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Attached By">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.attachedBy">
                    <span>{{dataItem.attachedBy}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Action" *ngIf="!hideAddDocumentButton">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <button type="button" kendoButton [icon]="'edit'" title='edit' [disabled]="isReadOnlyPage"
                    (click)="editDocument(uploadDocumentDialog,dataItem,rowIndex)"></button>
                <button type="button" kendoButton [icon]="'delete'" title='delete' [disabled]="isReadOnlyPage"
                    (click)="deleteDocument(dataItem,rowIndex)"></button>
                <button type="button" kendoButton [icon]="'download'" title='download'
                    (click)="downloadDocument(dataItem)"></button>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>

<ng-template #uploadDocumentDialog>
    <div [formGroup]="documentFormGroup">
        <div class="row">
            <div class="col-md-12">
                <kendo-textbox-container floatingLabel="Select Document Type" class="required-field">
                    <kendo-dropdownlist class="w-100" [valueField]="'DocumentTypeId'" [textField]="'Description'"
                        formControlName="documentType" [data]="documentTypeList" (valueChange)="documentTypeChange($event)">
                    </kendo-dropdownlist>
                </kendo-textbox-container>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div *ngIf="!isDocumentTypeSelected" class="gps-validation-error text-left"><span>Document type
                        required</span></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div k-toolbar>
                    <kendo-upload [autoUpload]="false" [restrictions]="uploadRestrictions" [disabled]="!disabledSelectFileButton"
                        (select)="selectEventHandler($event)" [multiple]="false" (clear)="clearEventHandler($event)"
                        (remove)="removeEventHandler($event)">
                    </kendo-upload>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div *ngIf="!isDocumentSelected" class="gps-validation-error text-left"><span>File required</span></div>
                <div *ngIf="isExistingDocumentName" class="gps-validation-error text-left"><span>Document alredy
                        exist</span></div>
            </div>
        </div>
        <div class="row" *ngIf="isEditDocumentDialug">
            <div class="col-md-10">
                <kendo-textbox-container floatingLabel="Document Name">
                    <input kendoTextBox formControlName="displayFileName">
                </kendo-textbox-container>
            </div>
            <div class="col-md-2 d-table">
                <span class="d-table-cell align-bottom">.{{fileExtension}}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <kendo-textbox-container floatingLabel="Description">
                    <input kendoTextBox value="" style="visibility:hidden; display:none" disabled />
                </kendo-textbox-container>
                <textarea class="w-100 mt-2" kendoTextArea placeholder=""
                    formControlName="documentDescription"></textarea>
            </div>
        </div>
        <div class="row" *ngIf="isExistingDocumentName">
            <div class="col-md-12">
                <fieldset>
                    <legend style="font-size: 18px;">Do you want to override?</legend>
                    <button type="button" class="mt-3" kendoButton [primary]="true"
                        (click)="overrideYes('Yes')">Yes</button>
                    <button type="button" class="mt-3" kendoButton [primary]="true"
                        (click)="overrideYes('No')">No</button>
                </fieldset>
            </div>
        </div>
        <div class="row" *ngIf="!isExistingDocumentName">
            <div class="col-md-12">
                <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'save'"
                    (click)="addDocument()" [disabled]="!disabledUploadButton"><span>Save</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewDocumentDialog>
    <div class="row sticky" *ngIf="!isEnablePDF">
        <div class="col-md-12 mt-0 mb-1">
            <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'download'"
                (click)="downloadDocument(enablePreviewDataItem)" title="Download"></button>
        </div>
    </div>
    <div class="row sticky" *ngIf="isEnablePDF">
        <div class="col-md-12 mt-0 mb-3">
            <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'download'"
                (click)="downloadDocument(enablePreviewDataItem)" title="Download"></button>
        </div>
    </div>
    <div class="">
        <div class="row" *ngIf="isEnableDOCX">
            <div class="col-md-12">
                <img src="../assets/images/no-preview.png" style="height: calc(100vh - 250px)" />
            </div>
        </div>
        <div class="row" *ngIf="isEnableJPG">
            <div class="col-md-12">
                <img [src]="url" style="height: calc(100vh - 250px)">
            </div>
        </div>
        <div class="row" *ngIf="isEnableTXT">
            <div class="col-md-12">
                <textarea readonly="true" style="width:100%;height: calc(100vh - 250px); background: white; 
            border-width: 1px;" kendoTextArea>{{url}}</textarea>
            </div>
        </div>
        <div class="row" *ngIf="isEnableXLXS">
            <div class="col-md-12 p-0">
                <div style="width: 100%; height: 450px; overflow: auto;">
                    <table id="TheTable" class="ExcelTable" style="width: 100%; height: 450px;">
                        <thead #header>
                            <tr>
                                <th *ngFor="let headValue of headData">
                                    {{headValue}}
                                </th>
                            </tr>
                        </thead>
                        <tbody #container>
                            <tr *ngFor="let row of data">
                                <td *ngFor="let val of headData; let i =index">
                                    {{row[i] || ' '}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isEnablePDF">
        <pdf-viewer [src]="url" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="true" [zoom]="1"
            [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true" [external-link-target]="'blank'"
            [autoresize]="false" [show-borders]="false" style="height: 100%; width: 100%; position: absolute;">
        </pdf-viewer>
    </div>
</ng-template>